import { Typography, SxProps, Theme } from '@mui/material';
import { forwardRef } from 'react';

export const TitleText = forwardRef<HTMLDivElement, { children: React.ReactNode; sx?: SxProps<Theme> }>(
  ({ children, sx }, reference) => {
    return (
      <Typography ref={reference} variant='h6' style={{ fontWeight: 600 }} sx={sx}>
        {children}
      </Typography>
    );
  }
);

TitleText.displayName = 'TitleText';
